import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Space,
  Popconfirm,
  Select,
  message,
  Card,
  Tag,
} from "antd";
import api from "../../api";

const UsersPage = () => {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [currentUserRole, setCurrentUserRole] = useState(null);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchCurrentUserRole = async () => {
    try {
      const response = await api.get("panel/user/info");
      setCurrentUserRole(response.data.data.user.role);
      console.log("یشده", response.data.data.user.role);
    } catch (error) {
      message.error("خطا در دریافت نقش کاربر");
      console.error(error);
    }
  };

  const fetchUsers = async (search = "") => {
    try {
      setLoading(true);
      const response = await api.get(
        `panel/users?includes[]=addresses&search=${search}`
      );
      setUsers(response.data.data);
    } catch (error) {
      message.error("خطا در دریافت لیست کاربران");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchRoles = async () => {
    try {
      const response = await api.get("panel/roles");
      setRoles(response.data.data);
    } catch (error) {
      message.error("خطا در دریافت نقش‌ها");
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCurrentUserRole();
    fetchUsers();
    fetchRoles();
  }, []);

  const handleEdit = (user) => {
  setEditingUser(user);
  const roleId = roles.find(role => role.name === user.role)?.id || null;
  
  form.setFieldsValue({
    name: user.name,
    email: user.email,
    number: user.number,
    role: roleId,  // Set the role ID here
    // status: user.status || 'approved' // Add status if needed
  });
  setIsModalVisible(true);
};

  const handleDelete = async (userId) => {
    try {
      await api.delete(`panel/users/${userId}`);
      message.success("کاربر با موفقیت حذف شد");
      fetchUsers();
    } catch (error) {
      message.error("خطا در حذف کاربر");
      console.error(error);
    }
  };

  const removeRoleFromUser = async (userId, roleId) => {
    try {
      await api.post("panel/roles/removeRoleFromUser", {
        user_id: userId,
        role_id: roleId,
      });
      message.success("نقش قبلی کاربر با موفقیت حذف شد");
    } catch (error) {
      message.error("خطا در حذف نقش قبلی کاربر");
      console.error(error);
    }
  };

  const handleSubmit = async (values) => {
    try {
      let res;
      if (editingUser) {
        // Update user information
        res = await api.post(`panel/users/${editingUser.id}?_method=PUT`, {
          name: values.name,
          email: values.email,
          number: values.number,
          password: values.password,
        });

        // If the current user is a super_admin, manage roles
        if (res?.data?.data?.id && currentUserRole === "super_admin") {
          // Remove the previous role (if any)
          if (editingUser.role) {
            const previousRole = roles.find(
              (role) => role.name === editingUser.role
            );
            if (previousRole) {
              await removeRoleFromUser(res.data.data.id, previousRole.id);
            }
          }

          // Assign the new role
          await api.post("panel/roles/assignRoleToUser", {
            user_id: res.data.data.id,
            role_id: values.role,
          });
        }

        message.success("کاربر با موفقیت به‌روزرسانی شد");
      } else {
        // Create a new user
        res = await api.post("panel/users", {
          ...values,
          // status: values.status,
        });

        // If the current user is a super_admin, assign the role
        if (res?.data?.data?.id && currentUserRole === "super_admin") {
          await api.post("panel/roles/assignRoleToUser", {
            user_id: res.data.data.id,
            role_id: values.role,
          });
        }

        message.success("کاربر با موفقیت ایجاد شد");
      }

      setIsModalVisible(false);
      form.resetFields();
      fetchUsers();
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;

        if (status === 422 && data?.data?.errors) {
          const errors = Object.values(data.data.errors).flat(); // Extract all errors
          message.error(errors.join(", ")); // Show errors as a single message
        } else {
          // Handle other errors
          message.error(data?.message || "خطا در ذخیره‌سازی کاربر");
        }
      } else {
        // Handle unexpected errors (e.g., network issues)
        message.error("یک خطای غیرمنتظره رخ داده است");
      }

      console.error("Error saving user:", error);
    }
  };

  const columns = [
    {
      title: "نام",
      dataIndex: "name",
      key: "name",
    },

    // {
    //   title: "نام شرکت",
    //   dataIndex: "company_name",
    //   key: "company_name",
    // },
    {
      title: "ایمیل",
      dataIndex: "email",
      key: "email",
    },

    {
      title: "موبایل",
      dataIndex: "number",
      key: "number",
    },
    // {
    //   title: "کشور",
    //   dataIndex: "country",
    //   key: "country",
    // },
    {
      title: "نقش",
      dataIndex: "role",
      key: "role",
    },

    {
      title: "تاریخ ایجاد",
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "اقدامات",
      key: "action",
      render: (_, record) => (
        <Space>
          <Button type="primary" onClick={() => handleEdit(record)}>
            ویرایش
          </Button>
          <Popconfirm
            title="آیا مطمئن هستید که می‌خواهید این کاربر را حذف کنید؟"
            onConfirm={() => handleDelete(record.id)}
            okText="بله"
            cancelText="خیر"
          >
            <Button type="primary" danger>
              حذف
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Card>
      <div style={{ padding: "24px" }}>
        <div
          className="flex justify-between mb-10"
          style={{ marginBottom: "16px" }}
        >
          <h1 className="text-xl">مدیریت کاربران</h1>
          <Space>
            <Input
              placeholder="جستجوی کاربران"
              onChange={(e) => fetchUsers(e.target.value)}
              style={{ width: 200 }}
            />
            <Button
              type="primary"
              onClick={() => {
                setEditingUser(null);
                form.resetFields();
                setIsModalVisible(true);
              }}
            >
              ایجاد کاربر جدید
            </Button>
          </Space>
        </div>

        <Table
          columns={columns}
          dataSource={users}
          rowKey="id"
          loading={loading}
          scroll={{ x: 1200 }}
        />

        <Modal
          title={editingUser ? "ویرایش کاربر" : "ایجاد کاربر جدید"}
          open={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          footer={null}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            autoComplete="off"
          >
            <Form.Item
              name="name"
              label="نام"
              rules={[{ required: true, message: "لطفاً نام را وارد کنید" }]}
            >
              <Input autoComplete="off" />
            </Form.Item>

            <Form.Item
              name="email"
              label="ایمیل"
              rules={[
                { required: true, message: "لطفاً ایمیل را وارد کنید" },
                { type: "email", message: "فرمت ایمیل نامعتبر است" },
              ]}
            >
              <Input autoComplete="off" />
            </Form.Item>

            <Form.Item
              name="number"
              label="موبایل"
              rules={[
                { required: true, message: "لطفاً شماره موبایل را وارد کنید" },
              ]}
            >
              <Input autoComplete="off" />
            </Form.Item>

            {currentUserRole === "super_admin" && (
              <Form.Item name="role" label="نقش">
                <Select allowClear>
                  {roles.map((role) => (
                    <Select.Option key={role.id} value={role.id}>
                      {role.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}

            {/* <Form.Item
              name="status"
              label="وضعیت"
              rules={[
                { required: true, message: "لطفاً وضعیت را انتخاب کنید" },
              ]}
            >
              <Select>
                <Select.Option value="approved">تایید شده</Select.Option>
                <Select.Option value="unapproved">تایید نشده</Select.Option>
              </Select>
            </Form.Item> */}

            <Form.Item
              name="password"
              label="رمز عبور"
              rules={[
                !editingUser && {
                  required: true,
                  message: "لطفاً رمز عبور را وارد کنید",
                },
              ]}
            >
              <Input.Password autoComplete="off" />
            </Form.Item>

            <Form.Item>
              <Space>
                <Button type="primary" htmlType="submit">
                  {editingUser ? "به‌روزرسانی" : "ایجاد"}
                </Button>
                <Button onClick={() => setIsModalVisible(false)}>لغو</Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </Card>
  );
};

export default UsersPage;
